//config
export * from './customers-config'

export * from './lib/customers-list/customers-list'
export * from './lib/customers-detail/customers-detail'
export * from './components/bt-sheet-components/customers-notifications-bottom-sheet/customers-notifications-bottom-sheet'
export * from './components/dialog-components/customer-details/customers-add-contact-dialog-component/customers-add-contact-dialog-component'
export * from './interfaces/customer-contacts.model'
export * from './interfaces/customer-notification.model'
export * from './services/customer-detail.service'
